import { buildContactUrl } from './gvode-wishlist-core.js';
import { getWishlistStore } from './gvode-wishlist-store.js';

const PRODUCT_SELECT_EVENT = 'shopify:product:select';

export class GvodeWishlistButton extends HTMLElement {
  connectedCallback() {
    this.eventTarget = this.closest('.shopify-section, dialog');
    this.eventTarget?.addEventListener(PRODUCT_SELECT_EVENT, this.handleProductSelect);
    if (this.hidden) return;

    this.store = getWishlistStore();
    this.item = {
      productId: this.dataset.productId,
      handle: this.dataset.handle,
      productTitle: this.dataset.productTitle,
      productUrl: this.dataset.productUrl,
      imageUrl: this.dataset.imageUrl,
      variantId: this.dataset.variantId,
      variantTitle: this.dataset.variantTitle,
      sku: this.dataset.sku,
      savedAt: new Date().toISOString(),
    };

    const contactLink = this.querySelector('[data-ref="contactLink"]');
    const saveButton = this.querySelector('[data-ref="saveButton"]');
    if (!contactLink || !saveButton) return;

    contactLink.href = buildContactUrl(this.item);
    this.saveButton = saveButton;
    this.saveButton.addEventListener('click', this.save);
    this.render(this.store.hasVariant(this.item.variantId));
  }

  disconnectedCallback() {
    this.eventTarget?.removeEventListener(PRODUCT_SELECT_EVENT, this.handleProductSelect);
    this.saveButton?.removeEventListener('click', this.save);
  }

  handleProductSelect = (event) =>
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const selector = `gvode-wishlist-button[data-block-id="${this.dataset.blockId}"]`;
        const replacement = detail.html.querySelector(selector);
        if (replacement) this.replaceWith(replacement);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[gvode-wishlist] Variant update failed:', error);
      });

  save = () => {
    const result = this.store.save(this.item);
    const region = this.querySelector('[data-ref="liveRegion"]');
    if (region) {
      region.textContent = result.ok
        ? 'Saved to your wishlist.'
        : 'Wishlist could not be saved in this browser.';
    }
    this.render(result.ok || this.store.hasVariant(this.item.variantId));
  };

  render(saved) {
    const button = this.querySelector('[data-ref="saveButton"]');
    const viewLink = this.querySelector('[data-ref="viewLink"]');
    if (!button || !viewLink) return;

    button.textContent = saved ? 'Saved' : 'Save to Wishlist';
    button.setAttribute('aria-pressed', String(saved));
    viewLink.hidden = !saved;
  }
}

if (!customElements.get('gvode-wishlist-button')) {
  customElements.define('gvode-wishlist-button', GvodeWishlistButton);
}
